//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex'
export default {
  name: 'over',
  computed: {
    ...mapState({
      pages: ({ pagesStore: {pages} }) => pages,
    }),
  },
  async fetch() {
    await Promise.all([ 
      this.$store.dispatch('pagesStore/getPage', 'info-over')
      ])
  },
  head() {
    return {
      title: this.pages.infoover ? this.pages.infoover.seo.title : 'Over | Info | Secret Circle',
      meta: [
        { hid: 'title', name: 'title', content: this.pages.infoover ? this.pages.infoover.seo.title : 'Over | Info | Secret Circle' },
        { hid: 'og:title', name: 'og:title', content: this.pages.infoover ? this.pages.infoover.seo.title : 'Over | Info | Secret Circle', },
        { hid: 'og:url', name: 'og:url', content: this.$config.feUrl + '/info/over' },
        { hid: 'og:description', name: 'og:description', content: this.pages.infoover ? this.pages.infoover.seo.description : 'Speel even met ons mee… Wat betekent seksfilms voor jou? Creëer maar eens een mooi beeld in je hoofd. Grote kans dat jij seksfilms associeert met begrippen als sexy, speels en spannend.' },
        { hid: 'description', name: 'description', content: this.pages.infoover ? this.pages.infoover.seo.description : 'Speel even met ons mee… Wat betekent seksfilms voor jou? Creëer maar eens een mooi beeld in je hoofd. Grote kans dat jij seksfilms associeert met begrippen als sexy, speels en spannend.' },
        { hid: 'keywords', name: 'keywords', content: this.pages.infoover ? this.pages.infoover.seo.keywords : 'over, over ons, Secret Circle, sexy, speels, spannend'},
        ]
    }
  },
}
